import { useCallback, useState } from 'react';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useDeletePixKeyMutation, useDeletePixKeyV2Mutation } from '../../services/pixKeysApi';
export function usePixKeyDelete() {
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isV2Enabled = isFeatureFlagWhiteListed(FeatureFlagUseCase.CORE_BANKING_ENABLE_BAAS_V2);
    const [deletePixKeyV1] = useDeletePixKeyMutation();
    const [deletePixKeyV2] = useDeletePixKeyV2Mutation();
    const deletePixKey = isV2Enabled ? deletePixKeyV2 : deletePixKeyV1;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleDeletePixKey = useCallback(async (key) => {
        setLoading(true);
        setError(null);
        try {
            await deletePixKey(key).unwrap();
            setError(null);
            return true;
        }
        catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Erro ao excluir chave Pix';
            setError(errorMessage);
            setLoading(false);
            return false;
        }
    }, [deletePixKey]);
    const stopLoading = useCallback(() => {
        setLoading(false);
    }, []);
    return {
        loading,
        error,
        handleDeletePixKey,
        stopLoading,
    };
}
